const IconSparkle = ({
  className,
  size = 10,
}: {
  className?: string
  size?: number
}) => (
  <svg
    aria-label="AI predicted"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.5}
    strokeLinecap="round"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Eight thin rays around a small filled center dot. vectorEffect
        "non-scaling-stroke" keeps each ray rendered at its declared
        1.5 raw pixels at every icon size — without it, the strokes
        scale with the SVG and anti-alias into invisibility around 8 px
        (which is exactly where DocumentEditScreen, DocumentPreview,
        and the Documents-table category column render this icon). */}
    <path
      vectorEffect="non-scaling-stroke"
      d="M8 1.5 L8 4.5 M8 11.5 L8 14.5 M1.5 8 L4.5 8 M11.5 8 L14.5 8"
    />
    <path
      vectorEffect="non-scaling-stroke"
      d="M3.4 3.4 L5 5 M12.6 12.6 L11 11 M12.6 3.4 L11 5 M3.4 12.6 L5 11"
    />
    <circle cx="8" cy="8" r="1.2" fill="currentColor" stroke="none" />
  </svg>
)

export default IconSparkle
